import {useRuntimeConfig} from "#app";

const runtimeConfig = useRuntimeConfig();
const env: string = runtimeConfig.public.appEnv;

export default (): boolean => {
	return env !== 'production';
}
